<template>
  <div class="row justify-content-center">
    <div class="col-md-8 col-lg-6 col-xl-5">
      <div class="text-center">
        <div class="text-error text-primary">
          4<i class="ion ion-md-sad mx-2"></i>3
        </div>
        <h3 class="text-uppercase">Accès refusé</h3>
        <p class="mt-4">
          Vous n'avez pas le droit d'acceder à cette page.
        </p>
        <br />
        <a class="btn btn-brown waves-effect waves-light" href="/dashboard">
          Accueil</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Page403",
  data: function() {
    return {
      title: "Erreur 403"
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + " | %s"
    };
  }
};
</script>

<style scoped></style>
